import RulesPageDefault from "../../../../components/Rules/RulesPageDefault";

export default function() {
    
    return (
        <div>
            <RulesPageDefault title="A. Questguard"/>
        </div>
    )
}